import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import cs from '../../../components/commonStyle.css';
import messages from '../../../locale/messages';

const RemarksModal = ({ show, onHide, remark, className, intl }) => (
  <Modal
    show={show}
    onHide={onHide}
    animation={false}
    backdrop="static"
    keyboard={false}
    className={cx('remarkModal languageModalContainer languageModalRTL', className)}
  >
    <Modal.Header closeButton className={cx(cs.fontDMSerif)}>
      <span>{intl.formatMessage(messages.remarksModal_fullRemark)}</span>
    </Modal.Header>
    <Modal.Body>
      <div style={{ wordBreak: 'break-word', fontSize: 16, lineHeight: 1.5 }}>
        {remark}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button
        className="btn btn-secondary"
        onClick={onHide}
      >
        {intl.formatMessage(messages.remarksModal_close)}
      </button>
    </Modal.Footer>
  </Modal>
);

RemarksModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  remark: PropTypes.string,
  className: PropTypes.string,
};

RemarksModal.defaultProps = {
  remark: '',
  className: '',
};

export default RemarksModal;
